const FAILURE_MARKERS = /\b(fail(?:ed|ure)?|error|not|no|unable|denied|invalid|missing|timeout|nicht|fehler|kein(?:e|en|er|es)?|nem|sikertelen|hiba|hiányzik)\b|_[a-z0-9_]*(?:failed|error|not|missing|invalid|timeout)/i;
const SUCCESS_MARKERS = /\b(sent|delivered|queued|accepted|gesendet|versendet|zugestellt|verschickt|kiküldve)\b|kiküldésre\s+ker/i;
/**
 * A failed delivery must never explain itself with a success message.
 * Preserve real provider errors, but suppress stale/inconsistent success text.
 */
export function getDisplayableEmailFailureReason(reason) {
    const normalized = reason?.trim();
    if (!normalized)
        return null;
    if (FAILURE_MARKERS.test(normalized))
        return normalized;
    if (SUCCESS_MARKERS.test(normalized))
        return null;
    return normalized;
}
